import React from 'react';
import { Switch, Route } from 'react-router-dom';
import NotFound from 'containers/Pages/Standalone/NotFoundDedicated';
import Outer from '../Templates/Outer';
import {
  Login, Register,
  LoginFullstack, RegisterFullstack,
  ResetPassword, ResetPasswordFullstack,
  ComingSoon, Maintenance, TwoFAQrcode, TwoFANum
} from '../pageListAsync';

function Auth() {
  return (
    <Outer>
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/register" component={Register} />
        <Route path="/reset-password" component={ResetPassword} />
        <Route path="/login-firebase" component={LoginFullstack} />
        <Route path="/register-firebase" component={RegisterFullstack} />
        <Route path="/reset-password-firebase" component={ResetPasswordFullstack} />
        <Route path="/maintenance" component={Maintenance} />
        <Route path="/coming-soon" component={ComingSoon} />

        <Route path="/twoFAQrcode" component={TwoFAQrcode} />
        <Route path="/twoFANum" component={TwoFANum} />

        <Route component={NotFound} />
      </Switch>
    </Outer>
  );
}

export default Auth;
